import {TrackableEntity} from './../data/ChangeTrackable';

export class AmsHm extends TrackableEntity {
    containerNo: string = '';
    id: number = 0;
    amsContainerId: number = 0;
    amsHouseId: number = 0;
    hmCode: string = '';
    hmClass: string = '';
    hmQualifier: string = '';
    hmDescript: string = '';
    hmContact: string = '';
    hmUnpage: string = '';
    flashPoint: number = 0;
    flashUnit: string = '';
    negative: string = '';
    created: string = '';
    modified: string = '';

    constructor(init?:Partial<AmsHm>) {
        super();
        this.key='id';
        Object.assign(this, init);
        if(this.id === 0) this.id = this.GetNextId();
    }
}
